<template>
  <div class="container middle gpxImport">

    <div class="header bottom-shadow">
      <label v-show="gpxUpload.state !== 2">Create a distance based route</label>
        <div class="loader" style="padding:20px" v-bind:class="{ 'loader-hide' : gpxUpload.state !== 2 }"></div>

    </div>

    <div class="inputs" style="margin-left:50px; margin-right:50px;">
          <div class="input-container">
            <input name="name" type="text" v-model="routeName" placeholder="Route Name">
          </div>
        </div>

    <BottomNav @previousPage="previousPage()" @nextPage="nextPage()" pText="Back" v-bind:pColor="pColor" nText="Create" v-bind:nColor="nColor"/>

  </div>
</template>

<script>

  import firebase from 'firebase'
  import BottomNav from './BottomNav'
  import { mapFields } from 'vuex-map-fields'
  import { store } from '../store/store'
  import moment from 'moment'
  import { userRef } from '../firebase'
  import axios from 'axios'

  export default {
    name: 'gpxImport',
    title: 'Runner - Gpx Import',
    data() {
      return {
        gpxUpload: {
          state: 0,
          length: 0,
          previewUrl: '',
          routeId: '',
          error: false
        },
        pColor: 'yellow',
        filename: 'Choose a file...',
        routeName: ''
      }
    },
    components: {
       BottomNav
    },
    computed: {
      isDisabled() {
        return this.gpxUpload.state != 2 ? false : true
      },
      nColor() {
        if (this.routeName !== '') {
          return 'green'
        } else {
          return 'gray'
        }
      }
    },
    asyncComputed: {
      showAdminContent() {
        return new Promise((resolve, reject) => {
          firebase.auth().currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            // Confirm the user is an Admin.
            if (idTokenResult.claims.admin && this.$route.params.addEvent) {
             resolve(true)
           } else {
             resolve(false)
           }
          })
          .catch((error) => {
            console.log(error)
            resolve(false)
          })
        })
      }
    },
    methods: {

      previousPage() {
      this.$router.replace('menu')
      },

    nextPage() {
      if (this.routeName !== '') {
        this.createRouteWithoutGpx()
      }
},
          createRouteWithoutGpx() {

          let data = {name: this.routeName}
          this.gpxUpload.state = 2

          firebase.auth().currentUser.getIdToken().then((token) => {
          axios({
           method: 'post', //you can set what request you want to be
           data: data,
           url: 'https://us-central1-racepeps.cloudfunctions.net/api/processNoGpx',
           headers: {
             'Authorization': 'Bearer ' + token
           }
          })
          .then(response => {
            console.log(response)
            this.$router.replace('userRaces')
          })
              })
    }
}
}

</script>

<style lang="scss" scoped>

  @import '../styles/styles.scss';

  .mid-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 8;
  }

  .bottom-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 2;

    span {
      padding: 10px;
      font-weight: 700;
      background-color: $cyan;
      color: white;
      cursor: pointer;
    }

  }

  .inputfile {
  	width: 0.1px;
  	height: 0.1px;
  	opacity: 0;
  	overflow: hidden;
  	position: absolute;
  	z-index: -1;
  }

  #gpxError {
    color: red;
    font-size: $font-medium;
    text-align: center;
    padding-right: 50px;
    padding-left: 50px;
    margin-top: 30px;
  }

  @media screen and (min-width: 1140px) {

    .gpxImport {
        width: 460px !important;
        height: 200px !important;
    }
  }

</style>
